import axios from './rest-axios';

const getCWLRB = (year) => axios.get('/manage/cw_lrb/', {year});

export {
    getCWLRB,
};
